import PropTypes from 'prop-types';
import React from 'react';
import Tablature from '../../../components/Tablature';
import { getTabLevelSettings } from '../../../lib/tab-data';

const LessonTablature = ({ instrument, level, tabs, type, toggleFullScreen }) => {
  return (
    <div className="lesson-tablature nt3">
      <Tablature
        tabs={tabs}
        type={type}
        settings={getTabLevelSettings(level, instrument)}
        toggleFullScreen={toggleFullScreen}
      />
    </div>
  );
};

LessonTablature.propTypes = {
  instrument: PropTypes.string,
  level: PropTypes.number,
  tabs: PropTypes.arrayOf(PropTypes.shape({})),
  type: PropTypes.string,
  toggleFullScreen: PropTypes.func,
};

LessonTablature.defaultProps = {
  instrument: '',
  level: 1,
  tabs: [],
  type: '',
  toggleFullScreen: () => {},
};

export default LessonTablature;
